(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/route-result/assets/javascripts/route-result.js') >= 0) return;  svs.modules.push('/components/tipsen/route-result/assets/javascripts/route-result.js');
"use strict";


const {
  ResultLayout
} = svs.components.tipsen.routeResult;
const {
  DrawProvider
} = svs.components.tipsen.drawProvider;
const RouteResult = () => React.createElement(DrawProvider, null, React.createElement(ResultLayout, null));
setGlobal('svs.components.tipsen.routeResult.RouteResult', RouteResult);

 })(window);